<inthraction-header class="fixed-header" *ngIf="authenticator.route == 'authenticated'"></inthraction-header>
<div class="main-wrapper">
  <router-outlet></router-outlet>
</div>
<inthraction-footer class="fixed-footer"></inthraction-footer>
